"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIRTUAL_GAMES_ENDPOINTS = void 0;
exports.VIRTUAL_GAMES_ENDPOINTS = [
    'virtual-game-tokens',
    'virtual-games/betgames/token',
];
//# sourceMappingURL=constants.js.map